var render = function render(_c, _vm) {
  return _c("h3", { class: _vm.$style.subTitle }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }